/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getPersonalDataOption() {
        return HttpService.get(environment.API_PERSONAL_DATA_OPTION);
    },

    getSensitivePersonalDataOption() {
        return HttpService.get(environment.API_SENSITIVE_PERSONAL_DATA_OPTION);
    },

    getPolicyCategory() {
        return HttpService.get(environment.API_GET_POLICY_CATEGORY);
    },

    getPolicyList(params) {
        return HttpService.get(environment.API_GET_POLICY_PRIVACY_NOTICE, {
            params,
        });
    },

    getFreeFormList(params) {
        return HttpService.get(environment.API_GET_FREE_FORM, {
            params,
        });
    },

    getHtml(params) {
        return HttpService.get(environment.API_GET_POLICY_HTML, {
            params,
        });
    },

    getPolicyNotice(privacyNoticeId) {
        return HttpService.get(
            environment.API_GET_POLICY_PRIVACY_NOTICE_NO_WFSECURE +
                '/' +
                privacyNoticeId
        );
    },

    getFreeForm(freeFormId) {
        return HttpService.get(
            environment.API_GET_FREE_FORM + '/' + freeFormId
        );
    },
    getDetailPublic(id) {
        return HttpService.get(
            environment.API_PUBLIC +
                '/privacy-policy/privacy-notice/publish-version/' +
                id
        );
    },
    getFreeFormDetailPublic(id) {
        return HttpService.get(
            environment.API_PUBLIC + '/free-form-policy/publish-version/' + id
        );
    },
    createPolicyNotice(payload) {
        return HttpService.post(
            environment.API_GET_POLICY_PRIVACY_NOTICE,
            payload
        );
    },

    updatePolicyNotice(payload) {
        return HttpService.put(
            environment.API_GET_POLICY_PRIVACY_NOTICE,
            payload
        );
    },

    updateFreeForm(payload) {
        return HttpService.put(environment.API_GET_FREE_FORM, payload);
    },

    rename(payload) {
        return HttpService.put(
            environment.API_GET_POLICY_PRIVACY_NOTICE + '/rename',
            payload
        );
    },
    delete(privacyNoticeId) {
        return HttpService.delete(
            environment.API_GET_POLICY_PRIVACY_NOTICE + '/' + privacyNoticeId
        );
    },
    deleteFreeForm(id) {
        return HttpService.delete(environment.API_GET_FREE_FORM + '/' + id);
    },
    history(params) {
        return HttpService.get(
            environment.API_GET_POLICY_PRIVACY_NOTICE + '/history',
            { params }
        );
    },
    downloadFile(payload) {
        return HttpService.post(
            environment.API_GET_POLICY_PRIVACY_NOTICE + '/export',
            payload
        );
    },
    count(params) {
        return HttpService.get(environment.API_GET_POLICY + '/count', {
            params,
        });
    },
    //History
    getHistories(params) {
        return HttpService.get(
            environment.API_GET_POLICY_PRIVACY_NOTICE + `/history`,
            {
                params,
            }
        );
    },
    getFreeFormHistories(params) {
        let objFilter = Object.assign({}, params);
        objFilter = { ...objFilter };
        return HttpService.get(environment.API_GET_FREE_FORM + `/history`, {
            params: objFilter,
        });
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_GET_POLICY_PRIVACY_NOTICE + `/history/detail`,
            {
                params,
            }
        );
    },
    getFreeFormHistoryDetail(params) {
        return HttpService.get(
            environment.API_GET_FREE_FORM + `/history/detail`,
            {
                params,
            }
        );
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_GET_POLICY_PRIVACY_NOTICE + `/publish-version/` + id
        );
    },
    getFreeFormPublishedVersion(id) {
        return HttpService.get(
            environment.API_GET_FREE_FORM + `/publish-version/` + id
        );
    },
};
